<template>
	<div id="giftExperience">
		<div class="position-relative">
			<div class="row-grid" id="scroller-container">
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/adresses.webp" alt="DES ADRESSES TRIÉES SUR LE VOLET" class="zoom-img">
						</div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">DES ADRESSES TRIÉES SUR LE VOLET</p>
              <p class="raleway-reg-p15">Nos hébergements sont sélectionnés un à un pour leur charme, leur confort et la qualité de leur accueil. Aucun compromis sur l’expérience.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/engagement-durable.webp" alt="UN ENGAGEMENT DURABLE" class="zoom-img">
						</div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">UN ENGAGEMENT DURABLE</p>
              <p class="raleway-reg-p15">Chaque adresse partage nos valeurs : respect de l’environnement, consommation raisonnée, et hospitalité durable. Pour un tourisme plus conscient.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/liberte-totale.webp" alt="UNE LIBERTÉ TOTALE" class="zoom-img">
						</div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">UNE LIBERTÉ TOTALE</p>
              <p class="raleway-reg-p15">Le coffret donne accès à tout le catalogue Hortense, sans contrainte de lieu ni de date. Le bénéficiaire choisit son séjour, à son rythme, partout en France.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/privileges-exclusifs.webp" alt="PRIVILÈGE EXCLUSIF" class="zoom-img">
						</div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">PRIVILÈGE EXCLUSIF</p>
              <p class="raleway-reg-p15">Chaque coffret inclut 1 privilège exclusif : early check in/late check out, bouteille de vin, massage, surclassement… Pour rendre le séjour inoubliable.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/guide-voyage-2.webp" alt="UN GUIDE DE VOYAGE PERSONNALISÉ" class="zoom-img">
						</div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">UN GUIDE DE VOYAGE INEDIT</p>
              <p class="raleway-reg-p15">Un guide pour découvrir des destinations sous le signe du charme et du tourisme durable : escapades culturelles, activités en pleine nature, balades inspirantes. Pour explorer à votre rythme, en conscience.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/accompagnement-sur-mesure.webp" alt="UN ACCOMPAGNEMENT SUR MESURE" class="zoom-img">
						</div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">UN ACCOMPAGNEMENT SUR MESURE</p>
              <p class="raleway-reg-p15">Notre conciergerie guide le bénéficiaire avec des conseils personnalisés et une écoute à chaque étape, pour trouver l'adresse idéale.</p>
            </div>
					</div>
				</div>
			</div>
			<div class="flex-shrink-0 previous-slide-button circle-icon" @click="scroll_left">
				<img src="../../images/arrow-left.svg" alt="Previous" />
			</div>
			<div class="flex-shrink-0 next-slide-button circle-icon" @click="scroll_right">
				<img src="../../images/arrow-right.svg" alt="Next" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'giftExperience',
		methods: {
			goToGroup(url){
				window.open(url, '_blank');
			},
			scroll_left() {
				let content = document.querySelector("#scroller-container");
				content.scrollLeft -= 220;
			},
			scroll_right() {
				let content = document.querySelector("#scroller-container");
				content.scrollLeft += 220;
			}
		},
	};
</script>

<style scoped lang="scss">

#giftExperience {
	padding-top: 70px;
  @media screen and (max-width: 767px) {
    padding-top: 10px;
  }

	.row-grid {
		display: flex;
		gap: 20px;
		overflow-x: auto;
		overflow-y: hidden;

    @media screen and (max-width: 767px) {
      gap: 12px;
    }
	}

	.col-hub {
		flex: 0 0 18%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.card-hub {
		position: relative;
		width: 100%;
	}

	.card-hub img {
		width: 100%;
		height: 400px;
		object-fit: cover;

    @media screen and (max-width: 767px) {
      width: 306px;
      height: 398px;
    }
	}

	.col-hub:nth-child(odd) .card-hub {
		transform: translateY(-15px);
	}

	.col-hub:nth-child(even) .card-hub {
		transform: translateY(15px);
	}
}
#scroller-container {
	overflow-x: scroll !important;
}

.circle-icon {
	width: 35px;
	height: 35px;
	border: 1px solid #000000B1;
	background: #000000B1 0% 0% no-repeat padding-box;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	img {
		width: 20px;
	}
}

.previous-slide-button {
	position: absolute;
	top: 50%;
	left: 3%;
	transform: translateY(-50%);
	color: white;

	@media screen and (max-width: 767px) {
		left: 0;
	}
}

.next-slide-button {
	position: absolute;
	top: 50%;
	right: 3%;
	transform: translateY(-50%);
	color: white;

	@media screen and (max-width: 767px) {
		right: 0;
	}
}
</style>
